import useInView from "@/lib/useInView";

/**
 * Reveal — fades / slides children into view when scrolled into viewport.
 *
 * Variants:
 *   - "up"     (default) translateY(24px) -> 0
 *   - "right"  translateX(-24px) -> 0
 *   - "fade"   opacity only
 *   - "scale"  scale(0.96) -> 1
 *
 * Use `delay` (ms) to stagger siblings.
 */
export default function Reveal({
  as: Tag = "div",
  variant = "up",
  delay = 0,
  className = "",
  children,
  ...rest
}) {
  const [ref, inView] = useInView();
  const anim = {
    up: "animate-brand-fade-up",
    right: "animate-brand-slide-right",
    fade: "animate-brand-fade-in",
    scale: "animate-brand-scale-in",
  }[variant];

  return (
    <Tag
      ref={ref}
      style={{ animationDelay: inView ? `${delay}ms` : "0ms" }}
      className={[
        "will-change-transform",
        inView ? anim : "opacity-0",
        className,
      ].join(" ")}
      {...rest}
    >
      {children}
    </Tag>
  );
}
